export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Artistic%20flatlay%20composition%20of%20curated%20fashion%20items%20including%20sneakers%20leather%20accessories%20and%20fabric%20swatches%20arranged%20in%20geometric%20pattern%20on%20warm%20terracotta%20surface%2C%20overhead%20view%20with%20natural%20window%20light%20creating%20soft%20highlights%2C%20editorial%20product%20styling%20with%20dried%20botanical%20accents%2C%20modern%20creative%20studio%20aesthetic%20with%20intentional%20negative%20space&width=1800&height=900&seq=hero-v2-main-M3n8&orientation=landscape&nocache=true"
        alt="Vigorbuy Spreadsheet organized product discovery and fashion categories"
        title="Vigorbuy Spreadsheet - Product Discovery Platform"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 leading-tight">
            Vigorbuy Spreadsheet — Discover The Best Products, Categories & Shopping Guides
          </h1>
          <p className="text-sm md:text-lg text-white/85 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
            Explore the latest Vigorbuy Spreadsheet resources, organized product collections, quality checking guides and expert shopping tips. Find better products faster with structured research.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
            >
              Vigorbuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/90 text-foreground-900 text-sm md:text-base font-semibold hover:bg-white transition-all duration-200 cursor-pointer whitespace-nowrap backdrop-blur-sm"
            >
              Buy It Now
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-8">
            <span className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
              Independent Resource
            </span>
            <span className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
              Updated Product Guides
            </span>
            <span className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
              Beginner Friendly
            </span>
            <span className="flex items-center gap-1.5 text-white/70 text-xs">
              <i className="ri-check-line text-white/80 w-4 h-4 flex items-center justify-center"></i>
              Safety Education
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}